import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { SupportService } from "../services/support-service";
import { AppService } from "../services/app.service";

@Component({
  selector: "app-region",
  templateUrl: "./region.component.html",
})
export class RegionComponent implements OnInit {
  cityList: any = [];
  stateId: any;
  countryCode: any = "US";
  path: any;

  constructor(
    private router: Router,
    private supportService: SupportService,
    private appService: AppService
  ) {}

  ngOnInit() {
    this.supportService.countryCode.subscribe((res) => {
      if (res) {
        this.countryCode = res;
      }
    });
    this.path = this.router.url;
    const splitpath = this.path.split("/");
    if (splitpath && splitpath.length === 3) {
      this.stateId = splitpath[2];
      this.getallcitycount();
    } else {
      this.supportService.stateId.subscribe((res) => {
        if (res) {
          this.stateId = res;
          this.getallcitycount();
        }
      });
    }
  }

  getallcitycount() {
    const data = {
      stateId: this.stateId,
    };
    this.appService.getallcitycount(data).subscribe((res) => {
      if (
        res &&
        res["status"] &&
        res["status"]["status"] &&
        res["status"]["status"] === 200
      ) {
        this.cityList = res["entity"];
      }
    });
  }

  goToMetro() {
    this.router.navigate(["/metro", this.countryCode]);
  }
}
